import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Button, Container, Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import gtm from '../lib/gtm';


function ContextError() {
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('xl'));

  useEffect(() => {
    gtm.push({ event: 'page_view' });
  }, []);

  return (
    <>
      <Helmet>
        <title>Error | Fintecsol Factoring</title>
      </Helmet>
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: 'background.paper',
          display: 'flex',
          minHeight: '100%',
          px: 3,
          py: '80px',
        }}
      >
        <Container maxWidth="lg">
          <Typography align="center" color="textPrimary" variant={mobileDevice ? 'h4' : 'h1'}>
            ¡Algo salió mal!
          </Typography>
          <Typography align="center" color="textSecondary" sx={{ mt: 2 }} variant="subtitle1">
            Recargue la página e intente nuevamente. En caso de que el error persista, por favor comuníquese con el
            administrador.
          </Typography>

          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
            <Box
              alt="Under development"
              component="img"
              src={`/static/error/error401_${theme.palette.mode}.svg`}
              sx={{ height: 'auto', maxWidth: '100%', width: 400 }}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 2,
              mt: 6,
              px: -3,
              justifyContent: 'center',
              width: '100%',
            }}
          >
            <Button
              variant="contained"
              onClick={() => {
                sessionStorage.clear();
                window.location.reload();
              }}
            >
              Recargar página
            </Button>
          </Box>
        </Container>
      </Box>
    </>
  );
}

export default ContextError;
